import {inject, Injectable} from '@angular/core';
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {
  CreateTechnicalConclusion,
  TechnicalConclusion,
  TechnicalConclusionFile
} from "../types/technical-conclusion-types";
import {technicalConclusionResourceType} from "../config/technical-conclusion-config";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class TechnicalConclusionModalService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public createTechnicalConclusion(createTechnicalConclusion: CreateTechnicalConclusion): Promise<TechnicalConclusion> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateTechnicalConclusion, TechnicalConclusion>(createTechnicalConclusion, technicalConclusionResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getFiles(getFilesParams: GetFilesParams): Promise<Array<TechnicalConclusionFile>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<TechnicalConclusionFile>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
